import {getLocalizationBasedOnLang} from '../../data/models/User/UserInfo';

const english = {
  title: 'Workspace dashboard',
  startTrial: 'Start your free trial',
  startTrialInfo:
    "Get started today with a 7-day free trial to explore tapybl's features and create courses at your own pace.",
  startTrialInfo2:
    'Enjoy the flexibility to upgrade or cancel anytime during your trial.',
  startTrialInfo3: 'Ready to elevate your teaching experience?',
  startTrialButton: 'Start trial',
  contactUsButton: 'Contact us',
  subcriptionEnded: 'Your trial has expired',
  subscriptionEndedInfo:
    'Choose a plan to unlock full access and keep your workspace running without limits. All your projects and data are safe so you can pick up right where you left off.',
  clickToSub: 'Please click on upgrade now to choose a plan',
  upgradeNow: 'Unlock full access',
  subscriptionExpired:
    'Sorry, it looks like this workspace cannot be accessed right now. Please contact your Administrator.',
  totalLearners: 'Total learners / instructors',
  totalCourses: 'Total published courses',
  spaceQuota: 'Storage quota',
  buyMoreSpace: 'Expand storage',
  aiActionsUsed: 'AI credits',
  upgradeForMoreActions: 'Add credits',
  avaialbleBalance: 'Available balance',
  exploreAddons: 'Explore add-ons',
  customizeWorkspace: 'Customize workspace',
  exporeIntegrations: 'Explore integrations',
  aiAssistants: 'AI assistants',
  manage: 'Manage',
  workspaceInsights: 'Workspace insights',
  userInsights: 'User insights',
  users: 'Users',
  addMoreSeats: 'Add more seats',
  totalUsers: 'Total users',
  learners: 'Learners',
  instructors: 'Instructors',
  available: 'Available',
  creators: 'Creator licenses',
  addCreators: 'Add licenses',
  timeSpent: 'Time spent on platform overall (all learners)',
  courseInsights: 'Course insights',
  courses: 'Courses',
  created: 'Created',
  published: 'Published',
  avgScore: 'Average score',
  courseStatus: 'Course status',
  completedCourses: 'Completions',
  inProgressCourses: 'In progress',
  notStartedCourses: 'Not started',
  trialBannerButton: 'our plans to sign up',
  check: 'Check ',
  trialBannerText: (period: string) =>
    `You have ${period} left in your trial, check `,
  day: 'day',
  hour: 'hour',
  availableOnlyForBusinessPlan: 'Available only in business plan',
  notAvailableForTrialPlan: 'Not available for trial plan',
};

const welsh = {
  title: 'Dangosfwrdd y gweithle',
  startTrial: 'Dechreuwch eich prawf am ddim',
  startTrialInfo:
    'Dechreuwch heddiw gyda prawf am ddim am 7 diwrnod i archwilio nodweddion tapybl a chreu cyrsiau yn eich cyflymder eich hun',
  startTrialInfo2:
    'Mwynhewch y hyblygrwydd i wella neu ganslo unrhyw bryd yn ystod eich prawf.',
  startTrialInfo3: 'Yn barod i gynyddu eich profiad dysgu?',
  startTrialButton: 'Dechreuwch y prawf',
  contactUsButton: 'Cysylltwch â ni',
  subcriptionEnded: 'Mae eich prawf wedi dod i ben',
  subscriptionEndedInfo:
    'Dewiswch gynllun i ddatgloi mynediad llawn a chadw eich gofod gwaith i redeg heb gyfyngiadau. Mae’ch holl brosiectau a data’n ddiogel, felly gallwch barhau’n union lle gwnaethoch adael.',
  clickToSub: 'Cliciwch ar uwchraddio nawr i ddewis cynllun, os gwelwch yn dda',
  upgradeNow: 'Datgloi mynediad llawn',
  subscriptionExpired:
    "Mae'n ddrwg gennyf, mae'n edrych fel nad oes modd cyrchu'r gweithle hwn ar hyn o bryd. Cysylltwch â'ch Gweinydduwr os gwelwch yn dda.",
  totalLearners: 'Cyfanswm dysgwyr / hyfforddwyr',
  totalCourses: 'Y cyrsiau cyhoeddedig cyfan',
  spaceQuota: 'Cwota gofod',
  aiActionsUsed: 'Credydau AI ar gael',
  avaialbleBalance: 'Available balance',
  buyMoreSpace: 'Ehangu storfa',
  upgradeForMoreActions: 'Ail-lwytho credydau',
  customizeWorkspaceBranding: "Addasu brandio'r gweithle",
  manageAccount: 'Rheoli cyfrif',
  manageIntegrations: 'Rheoli integreiddiadau',
  quickLinks: 'Dolenni cyflym',
  totalAuthors: 'Creuwyr cyrsiau',
  totalCreatedCourses: 'Cyfanswm cyrsiau a grëwyd',
  buyMoreUsers: 'Ychwanegu seddau defnyddiwr',
  getUnlimitedCourses: 'Cewch gyrsiau di-ben-draw',
  workspaceInsights: 'Workspace insights',
  userInsights: 'User insights',
  trialBannerButton: 'ein cynlluniau i gofrestru',
  check: 'Gwiriwch ',
  trialBannerText: (period: string) =>
    `Mae gennych ${period} ar ôl yn eich cyfnod prawf, gwiriwch `,
  day: 'diwrnod',
  hour: 'awr',
  availableOnlyForBusinessPlan: 'Ar gael yn y cynllun busnes yn unig',
  creators: 'Trwyddedau creu',
  addCreators: 'Ychwanegu trwyddedau',
  notAvailableForTrialPlan: 'Nid yw ar gael ar gynllun prawf',
};

export const dashboardText: any = getLocalizationBasedOnLang(english, welsh);
